const isInList = (list, name, key = "attributes.alias") => {
    if (!Array.isArray(list) || !name) return false;

    const keyParts = key.split(".");
    return list.some((item) => {
        let value = item;
        for (const part of keyParts) {
            if (value && typeof value === "object" && part in value) {
                value = value[part];
            } else {
                return false;
            }
        }
        return value === name;
    });
};
export default isInList;
